import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetPositionsTemplateQueryResponse, GetPositionsTemplateQueryParams, GetPositionsTemplate400, GetPositionsTemplate401, GetPositionsTemplate403, GetPositionsTemplate422, GetPositionsTemplate429, GetPositionsTemplate500 } from "../types/GetPositionsTemplate";

export const getPositionsTemplateQueryKey = (params: GetPositionsTemplateQueryParams) =>     [{url:`/api/purchase-tenders/v1/position-template`},...(params ? [params] : [])] as const;
      export function getPositionsTemplateQueryOptions <TData = GetPositionsTemplateQueryResponse, TError = GetPositionsTemplate400 | GetPositionsTemplate401 | GetPositionsTemplate403 | GetPositionsTemplate422 | GetPositionsTemplate429 | GetPositionsTemplate500>(params: GetPositionsTemplateQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getPositionsTemplateQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/position-template`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/position-template
 */

export function useGetPositionsTemplate <TData = GetPositionsTemplateQueryResponse, TError = GetPositionsTemplate400 | GetPositionsTemplate401 | GetPositionsTemplate403 | GetPositionsTemplate422 | GetPositionsTemplate429 | GetPositionsTemplate500>(params: GetPositionsTemplateQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPositionsTemplateQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getPositionsTemplateQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
